import React, { PureComponent, Fragment, useState } from 'react';
import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import '@ant-design/compatible/assets/index.css';
import {
  Input,
  Button,
  Checkbox,
  Row,
  Col,
  message,
  Modal,
  Tooltip,
  Form,
  Radio,
  Space,
  Divider,
} from 'antd';
import { connect } from 'dva';
import Label from '@/components/Label/Label';
import styles from './BasicAWSOverview.module.css';
import CoverageStatusConnections from '../CoverageStatusConnections';
import { COLOR } from '@/utils/color';
import { showDeleteConfirm } from '../showDeleteConfirm';
import DeleteCloudAccountWrapper from '../ConfigurationTab/Components/DeleteCloudAccountWrapper';
import OverviewInfoBar from '../ConfigurationTab/Components/OverviewInfoBar';

const BasicAWSOverview = props => {
  const { cloudAccountData, updateData } = props;

  return (
    <>
      <OverviewInfoBar cloudAccountData={cloudAccountData} />

      <Row>
        <Col span={12}>
          <CoverageStatusConnections
            cloudAccountData={cloudAccountData}
            isEditCloudAccount={true}
          />
        </Col>
      </Row>

      {/* <Divider /> */}

      {/* <DeleteCloudAccountWrapper
        handleDeleteAccount={props.handleDeleteAccount}
        handleDisbaledAccount={props.handleDisbaledAccount}
        showDisableAction={cloudAccountData.isActive}
        cloudAccountName={cloudAccountData.accountName}
        cloudAccountData={cloudAccountData}
      /> */}
    </>
  );
};

// export default BasicAWSOverview;
export default connect(({ cloudAccount, loading }) => ({
  updating: cloudAccount.updating,
}))(BasicAWSOverview);

const RoleARNTooltip = () => {
  const [visible, setVisible] = useState(false);
  const showModal = () => {
    setVisible(true);
  };
  const handleOk = e => {
    setVisible(false);
  };
  const handleCancel = e => {
    setVisible(false);
  };

  return (
    <span>
      Role ARN&nbsp;
      <Tooltip title="Help">
        <QuestionCircleOutlined style={{ verticalAlign: 0 }} onClick={showModal} />
      </Tooltip>
      <Modal
        title="Amazon Resource Number (ARN)"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>
          <b>Step 1: </b>
          To create IAM Role, log in to your AWS IAM console{' '}
          <a target="blank" href="https://signin.aws.amazon.com/">
            {' '}
            <b>https://signin.aws.amazon.com/</b>{' '}
          </a>
          .
        </p>
        <p>
          <b>Step 2: </b>
          Click 'Roles' in side menu, click on "Create Role" button.
        </p>
        <p>
          <b>Step 3: </b>
          Click on 'Another AWS Account' box, copy your Account ID from cloudnosys dashboard and
          paste it in the Account field of aws console.
        </p>
        <p>
          <b>Step 4: </b>
          Click on the "Require external ID" checkbox, copy the external Id from your cloudnosys
          dashboard and paste it the External Id field of aws console, then click next.
        </p>
        <p>
          <b>Step 5: </b>
          In the next screen that appears, search for your desired policy and add it, click next.
        </p>
        <p>
          <b>Step 6: </b>
          Enter valid name and description in next Review Policy screen, then click Create Policy.
        </p>
        <p>
          <b>Step 7: </b>
          This would successfully create your IAM Role and generate a <b>Role ARN</b>.
        </p>
        <p>
          <b>Step 8: </b>
          To get your Role ARN, navigate back to <b>Roles</b> in AWS console, locate your Role name,
          click on that and it would open up your role summary, displaying your <b>Role ARN</b> on
          the top.
        </p>
        <p>
          <b>Step 9: </b>
          Copy <b>Role ARN</b> from AWS console and paste it in the Role ARN field in Cloudnosys
          Dashboard.
        </p>
      </Modal>
    </span>
  );
};
